/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import Expander from '@amzn/meridian/expander';

const ControlledExpander = (props) => {
  const [open, setOpen] = useState();
  return <Expander open={open} onChange={setOpen} {...props} />;
};

export default ControlledExpander;
